import { useRef, useTransition } from 'react';
import Input from 'react-phone-number-input/input';

import { PhoneInputProps } from './types';

export const PhoneInput = ({
  name,
  value,
  onChange,
  ...props
}: PhoneInputProps) => {
  const [, startTransition] = useTransition();
  const prevValueRef = useRef(value ?? '');

  return (
    <Input
      {...props}
      country="US"
      value={value}
      onChange={(newValue) => {
        const normalized = newValue ?? '';

        if (normalized === prevValueRef.current) return;
        prevValueRef.current = normalized;

        startTransition(() => {
          onChange?.({ target: { name, value: normalized } });
        });
      }}
    />
  );
};
